export const WELCOME_SECTION_CONTENTS = {
  title2: "winter-section1-title-2",
  date: "winter-section1-date",
  description: "winter-section1-description",
};

export const SECOND_SECTION_CONTENTS = [
  // TODO: uncomment when splashbay is ready
  {
    id: 1,
    image: "Room_Offer_1.jpg",
    bookLink: "16SA2N",
    viewLink: "/offers/detail/2night-summer-adventure-package",
  },
  {
    id: 2,
    image: "Room_Offer_2.jpg",
    title: "Splash Bay Room Package",
    date: "Stay Period | Jan 15, 2025 - Apr 30, 2025",
    price: "256,000 KRW ~",
    bookLink: "14INIRD",
    viewLink: "/offers/detail/romantic-summer-escape-package",
  },
  {
    id: 3,
    image: "Room_Offer_New_3.jpg",
    title: "Chef’s Kitchen Breakfast Package (Session 2)",
    date: "Stay Period | - Apr 30, 2025",
    price: "316,000 KRW ~ ",
    bookLink: "17INSP1",
    viewLink: "/offers/detail/splash-bay-package",
  },
  {
    id: 4,
    image: "Room_Offer_New_4.jpg",
    title: "2025 Lunar New Year : In-Room Dining Special",
    date: "Stay Period | Jan 13, 2024 - Jan 31, 2025",
    price: "303,000 KRW ~",
    bookLink: "14SDW",
    viewLink: "/offers/detail/preflight-overnight-package-campaign",
  },
];

export const THIRD_SECTION_CONTENTS = [
  {
    id: 1,
    image: "4_1.jpg",
  },
  {
    id: 2,
    image: "4_2.jpg",
  },
  {
    id: 3,
    image: "4_3.jpg",
  },
];

export const NINTH_SECTION_CONTENTS = [
  {
    id: 1,
    image: "special-event_new_1.jpg",
    link: "/offers/detail/premium-tanning-zone",
  },
  {
    id: 2,
    image: "special-event_new_2.jpg",
    link: "/offers/detail/splash-pop-event",
  },
  {
    id: 3,
    image: "special-event_new_3.jpg",
    link: "/offers/detail/INSPIRE-kids-camp",
  },
];

export const FOURTH_SECTION_CONTENTS = [
  {
    id: 1,
    image: "F&B_1.jpg",
    link: "/offers/detail/dessert-buffet-tropical-mango",
  },
  {
    id: 2,
    image: "F&B_2.jpg",
    link: "/offers/detail/mango-blueberry-bingsu-special",
  },
  {
    id: 3,
    image: "F&B_New_3.jpg",
    link: "/offers/detail/INSPIRE-afternoont-tea-mango-delights",
  },
];

export const FIFTH_SECTION_CONTENTS = [
  {
    id: 1,
    image: "special-event_1.jpg",
    link: "/offers/detail/INSPIRE-play-pass",
  },
  {
    id: 2,
    image: "special-event_2.jpg",
    link: "/offers/detail/evening-yoga-sessions",
  },
  {
    id: 3,
    image: "special-event_3.jpg",
    link: "/offers/detail/sunset-nature-run",
  },
];

export const SIXTH_SECTION_CONTENTS = [
  {
    id: 1,
    image: "Arena_New_1.jpg",
    link: "/entertainment/performance/twice-world-tour-in-incheon",
  },
  {
    id: 2,
    image: "Arena_New_2.jpg",
    link: "/entertainment/performance/lck-roadshow2025-T1-homeground",
  },
  {
    id: 3,
    image: "Arena_New_3.jpg",
    link: "/entertainment/performance/2025-LeeSeungChul-concert-Orchestrock2-incheon",
  },
];
